export default __webpack_public_path__ + "static/media/sklearn.e9b7ae04.svg";